import React from "react";
import { Landmark, Building2, CalendarDays, BadgeInfo, FileText } from "lucide-react";
import { Sekcja, RowIcon } from "./atoms";

export default function UreLicensesSection({ items = [] }) {
  return (
    <Sekcja
      title="Koncesje URE"
      icon={Landmark}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      {Array.isArray(items) && items.length > 0 ? (
        <div style={{ display: "grid", gap: 12 }}>
          {items.map((u, i) => (
            <div key={i}>
              {/* Nagłówek wpisu (bez tła/borderów) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                  marginBottom: 4,
                }}
              >
                <div style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 700 }}>
                  <Landmark size={16} />
                  <span>{u?.company_name || "—"}</span>
                </div>
                <div style={{ fontWeight: 800, color: "#374151" }}>
                  {u?.short_code ? <span>{u.short_code}</span> : <em>—</em>}
                </div>
              </div>

              {/* Wiersze danych w tym samym stylu co inne sekcje */}
              <RowIcon icon={CalendarDays} label="Ważna od">
                {u?.valid_from || <em>—</em>}
              </RowIcon>
              <RowIcon icon={CalendarDays} label="Ważna do">
                {u?.valid_to || <em>—</em>}
              </RowIcon>
              <RowIcon icon={Building2} label="Podmiot">
                {u?.company_name || <em>—</em>}
              </RowIcon>
              <RowIcon icon={BadgeInfo} label="Kod">
                {u?.short_code || <em>—</em>}
              </RowIcon>
              <RowIcon icon={FileText} label="Opis">
                {u?.description || <em>—</em>}
              </RowIcon>
            </div>
          ))}
        </div>
      ) : (
        <em>Brak koncesji URE.</em>
      )}
    </Sekcja>
  );
}
